import useStyles from './styles';
import useNewStyles from './new_styles';
import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon';
const JetAccordion = (props: any) => {
  const classes = props.newui ? useNewStyles() : useStyles();
  const { className, ...otherProps } = props;
  const classNames = ['jetAccordion', classes.JetAccordion, className].join(
    ' '
  );
  const typographyClass = props.typographyClass || 'heading_s';
  return (
    <Accordion className={classNames} {...otherProps} style={{width:(props.width ? `${props.width}px` : 'unset')}}>
      <AccordionSummary
        expandIcon={
          <JetFontIcon
            className={classes.JetAccordionIcon}
            iconname={JET_FONTICON_ALIASES.CHEVRON_DOWN}
            size={props.iconSize || 10}
          />
        }
      >
        {!props.newui ? (
          <Typography
            variant={props.typographyVariant || 'h5'}
            className={` ${typographyClass} ${
              props.color === 'default'
                ? classes.JetAccordionTitleDefault
                : classes.JetAccordionTitle
            }`}
          >
            {props.title}
          </Typography>
        ) : (
          <Typography className="body_regular" variant="body1">
            {props.title}
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
};

export default JetAccordion;
